import { CARGAR_FACTURAS_FECHA, CARGAR_DEVOLUCIONES_FECHA, CARGAR_DESCUENTOS_FECHA, CARGAR_PROFORMAS_FECHA, CARGAR_PEDIDO_PROCESO_FECHA, CARGAR_ARTICULOS_FECHA} from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';

export const cargarFacturasFecha= (query) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/vendedoresconsulta/cargar-facturas-fecha/'+query
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
            let facturas = response.data.facturas;		
			dispatch({
				type: CARGAR_FACTURAS_FECHA,
				data: facturas
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar facturas', mensaje: msgError}
			});
		})
	}
}
export const cargarDevolucionesFecha= (query) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/vendedoresconsulta/cargar-devoluciones-fecha/'+query
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let devoluciones = response.data.devoluciones;
			console.log(devoluciones)		
			dispatch({
				type: CARGAR_DEVOLUCIONES_FECHA,
				data: devoluciones
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar devoluciones', mensaje: msgError}
			});
		})
	}
}
export const cargarDescuentosFecha= (query) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/vendedoresconsulta/cargar-descuentos-fecha/'+query
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let descuentos = response.data.descuentos;
			console.log(descuentos)		
			dispatch({
				type: CARGAR_DESCUENTOS_FECHA,
				data: descuentos
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar descuentos', mensaje: msgError}
			});
		})
	}
}
export const cargarProformasFecha= (query) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/vendedoresconsulta/cargar-proformas-fecha/'+query
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let proformas = response.data.proformas;
			console.log(proformas)		
			dispatch({
				type: CARGAR_PROFORMAS_FECHA,
				data: proformas
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proformas', mensaje: msgError}
			});
		})
	}
}
export const cargarPedidoProcesoPorFecha= (query) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/vendedoresconsulta/cargar-pedido-proceso-fecha/'+query
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let pedidoprocesos = response.data.pedidoprocesos;
			dispatch({
				type: CARGAR_PEDIDO_PROCESO_FECHA,
				data: pedidoprocesos
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar pedido procesos', mensaje: msgError}
			});
		})
	}
}
export const cargarArticulosPedidoFecha= (query) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/vendedoresconsulta/cargar-detalle-articulo-pedido-fecha/'+query
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let articulos = response.data.detalleArticuloPedidos;
			console.log(articulos)		
			dispatch({
				type: CARGAR_ARTICULOS_FECHA,
				data: articulos
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar articulos pedido', mensaje: msgError}
			});
		})
	}
}
